<app-additional-action-header 
  data-testid="what-to-do-header"
  [title]="locale.currentTranslation.whatToDoIncident"/>
<div class="base-content-container" data-testid="what-to-do-content">
  <div class="card" data-testid="emergency-response-card">
    <p class="headline3" data-testid="emergency-response-headline">
      {{ locale.currentTranslation.whatToDoIncidentHeadline1 }}
    </p>

    <div data-testid="immediate-actions-section">
      <p class="text-body2" style="margin-bottom: 0" data-testid="damage-description">
        {{ locale.currentTranslation.whatToDoIncidentDamage }}
      </p>

      <ul style="margin-top: 0" data-testid="immediate-actions-list" aria-label="Immediate actions to take">
        <li class="text-body2" data-testid="action-contact">
          {{ locale.currentTranslation.whatToDoIncidentContact }}
        </li>
        <li class="text-body2" data-testid="action-secure-persons">{{ locale.currentTranslation.whatToDoIncidentSecurePersons }}</li>
        <li class="text-body2" data-testid="action-secure-location">{{ locale.currentTranslation.whatToDoIncidentSecureIncidentLocation }}</li>
      </ul>
    </div>

    <div data-testid="emergency-contacts-section">
      <p class="text-body2 text-bold " style="margin-bottom: 0" data-testid="emergency-numbers-heading">
        {{ locale.currentTranslation.whatToDoIncidentEmergencyNumber }}
      </p>
      <ul style="margin-top: 0" data-testid="emergency-contacts-list" aria-label="Emergency contact numbers">
        <li class="text-body2" data-testid="police-contact">
          {{ locale.currentTranslation.whatToDoIncidentPolice }} 
          <a class="text-body2" 
             href="tel:110" 
             data-testid="emergency-police-link"
             aria-label="Call police at 110">110</a>
        </li>
        <li class="text-body2" data-testid="ambulance-contact">
          {{ locale.currentTranslation.whatToDoIncidentAmbulanceService }} 
          <a class="text-body2" 
             href="tel:112" 
             data-testid="emergency-ambulance-link"
             aria-label="Call ambulance service at 112">112</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="card" data-testid="documentation-card">
    <p class="headline3" data-testid="documentation-headline">
      {{ locale.currentTranslation.whatToDoIncidentHeadline2 }}
    </p>

    <div data-testid="documentation-section">
      <p class="text-body2" style="margin-bottom: 0" data-testid="documentation-description">
        {{ locale.currentTranslation.whatToDoIncidentNotes }}
      </p>
      <ul style="margin-top: 0" data-testid="documentation-list" aria-label="Documentation steps">
        <li class="text-body2" data-testid="doc-site">{{ locale.currentTranslation.whatToDoIncidentSite }}</li>
        <li class="text-body2" data-testid="doc-police-report">{{ locale.currentTranslation.whatToDoIncidentPoliceReport }}</li>
        <li class="text-body2" data-testid="doc-pictures">{{ locale.currentTranslation.whatToDoIncidentPicture }}</li>
        <li class="text-body2" data-testid="doc-perspectives">{{ locale.currentTranslation.whatToDoIncidentMultiplePerspective }}</li>
      </ul>
    </div>
  </div>

  <div class="card" data-testid="claim-process-card">
    <p class="headline3" data-testid="claim-process-headline">
      {{ locale.currentTranslation.whatToDoIncidentHeadline3 }}
    </p>

    <div data-testid="claim-process-section">
      <p class="text-body2 text-bold" style="margin: 0;" data-testid="scooter-info-heading">
        {{ locale.currentTranslation.whatToDoIncidentScooter }}
      </p>
      <p class="text-body2" style="margin-top: 0" data-testid="digital-claim-info">
        {{ locale.currentTranslation.whatToDoIncidentDigitalIncidentClaim }}
      </p>

      <p class="text-body2 text-bold" style="margin: 0;" data-testid="third-party-heading">
        {{ locale.currentTranslation.whatToDoIncidentThirdParty }}
      </p>
      <p class="text-body2" style="margin-top: 0" data-testid="self-claim-info">
        {{ locale.currentTranslation.whatToDoIncidentSelf }}
      </p>

      <p class="text-body2 text-bold" style="margin: 0;" data-testid="hint-heading">
        {{ locale.currentTranslation.whatToDoIncidentHint }}
      </p>
      <ul style="margin-top: 0" data-testid="claim-hints-list" aria-label="Claim process hints">
        <li class="text-body2" data-testid="hint-claim">{{ locale.currentTranslation.whatToDoIncidentClaim }}</li>
        <li class="text-body2" data-testid="hint-information">{{ locale.currentTranslation.whatToDoIncidentAllInformation }}</li>
        <li class="text-body2" data-testid="hint-insurer">{{ locale.currentTranslation.whatToDoIncidentInsurer }}</li>
      </ul>
    </div>
  </div>
  <button class="main-button" 
          routerLink="/insurance-information"
          data-testid="claim-incident-button"
          aria-label="Proceed to claim incident">
    {{ locale.currentTranslation.claimIncident }}
  </button>
  <app-footer data-testid="what-to-do-footer" />
</div>
